import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  response: [],
  referenceNos: [],
  isFetching: false,
  isSuccess: false,
  isResponse: false,
  isAddResponse: false,
  isError: false,
  errorMessage: '',
  documentDetailData: {},
  isdocumentDetailData: false,
  SignData: [],
  signCount: 0,
  isSignSuccess: false,
  imagePath: '',
};


export const getIncryptedPDF = createAsyncThunk(
  'api/clerk/givePdf?pdfName',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;

      let response = await axios({
        url: `/api/clerk/givePdf?pdfName=${udata}`,
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      let error = err;
      if (!error.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
);


export const DocumentSignatureSlice = createSlice({
  name: 'documentsignature',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, { payload }) => {
      state.response = [];
      state.isError = false;
      state.isSuccess = false;
      state.isResponse = false;
      state.isAddResponse = false;
      state.errorMessage = '';
    },
    setUploadDocState: (state, { payload }) => {
      state.isAddResponse = true;
      state.response = payload.data;
    },
    unsetUploadDocState: (state, { payload }) => {
      state.isAddResponse = false;
    },
    setDocumentDetailState: (state, { payload }) => {
      state.isdocumentDetailData = true;
      state.documentDetailData = payload.data;
    },
    setSignListDetailState: (state, { payload }) => {
      state.SignData = payload.data.data;
      state.signCount = payload.data.count;
      state.imagePath = payload.data.path;
      state.isSignSuccess = true;
    },
    unsetSignListDetailState: (state) => {
      state.SignData = [];
      state.signCount = 0;
      state.imagePath = '';
      state.isSignSuccess = false;
    },
  }
});

export const { clearStateSlice, setUploadDocState, unsetUploadDocState, setDocumentDetailState, unsetDocumentDetailState, setSignListDetailState, unsetSignListDetailState } = DocumentSignatureSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export function clearAddResponseState() {

  return async (dispatch) => {
    dispatch(unsetUploadDocState());
  }
}

export const documentSignatureSelector = (state) => state.documentsignature;

export const UploadSignedDocumentAsyn = (bdata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';

  //  const response = await axios.post('/api/clerk/signedApi',bdata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });
  const response = await axios.post(`/api/${userType}/signedApi`, bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  //console.log(data.data)
  dispatch(setUploadDocState(data));
  return data;
};

export const UploadSignedDocumentV2Asyn = (bdata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';

  //  const response = await axios.post('/api/clerk/signedApi',bdata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });
  const response = await axios.post(`/api/${userType}/v2/signedApi`, bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  //console.log(data.data)
  dispatch(setUploadDocState(data));
  return data;
};

export function unsetDocumentDetailStateAsync() {

  return async (dispatch) => {
    dispatch(unsetDocumentDetailState());
  }
}

export const getDocumentDetailAsyn = (pdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
    let response = await axios({
      url: `/api/${userType}/document/detailed?processId=${pdata}`,
      method: 'get',
      //timeout: 8000,
      headers: {
        //'Content-Type': 'application/json',
        "Authorization": `Bearer ${tokenStr}`
      }
    })

    let data = response.data;
    dispatch(setDocumentDetailState(data));
    return data;
    // console.log(data.data)
    //dispatch(getAllUserDepartments(data));
  } catch (error) {
    return error.response.data;
  }
};


export const getDocumentDetailV2Asyn = (pdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
    let response = await axios({
      url: `/api/${userType}/v2/document/detailed?processId=${pdata}`,
      method: 'get',
      //timeout: 8000,
      headers: {
        //'Content-Type': 'application/json',
        "Authorization": `Bearer ${tokenStr}`
      }
    })

    let data = response.data;
    dispatch(setDocumentDetailState(data));
    return data;
    // console.log(data.data)
    //dispatch(getAllUserDepartments(data));
  } catch (error) {
    return error.response.data;
  }
};

export const EncrptyPdfDataDelAsyn = (bdata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
  let response = await axios({
    url: `/api/clerk/removePdf?pdfName=${bdata}`,
    method: 'delete',
    headers: {
      "Authorization": `Bearer ${tokenStr}`
    }
  })
  let data = response.data;
  return data;
};


export function clearSignatureListState() {

  return async (dispatch) => {
    dispatch(unsetSignListDetailState());
  }
}

export const getSignatureListAsyn = (pdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
    let response = await axios({
      url: `/api/${userType}/signature`,
      method: 'get',
      //timeout: 8000,
      headers: {
        //'Content-Type': 'application/json',
        "Authorization": `Bearer ${tokenStr}`
      }
    })

    let data = response.data;
    dispatch(setSignListDetailState(data));
    return data;
    // console.log(data.data)
    //dispatch(getAllUserDepartments(data));
  } catch (error) {
    return error.response.data;
  }
};



export default DocumentSignatureSlice.reducer;
